import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool } from "@/tool";
import { parse } from "querystring";
import base64url from 'base64-url'
import moment from 'moment'
import PlayerContainer, { Layer, MessageContext } from "griffith";
import classnames from 'classnames'
import LayerTest from './LayerTest'
import "./index.less";

const { WizContainer, modelUtils } = framework_tool
const { WizLayout, WizSpin, WizEmpty, WizDropdown, WizMenu, WizIcon, WizButton, Wizmessage } = component_tool
class VideoList extends WizContainer {

  componentName = 'VideoList';

  constructor(props) {
    super(props);
    this.state = {
      playUrl : '',
      playKey: 'playKey',
      activeKey: 0,
      visible: false
    }
    const search = window.location.href.split("?")[1]
    const getPageQuery = () => parse(search);
    this.query = getPageQuery()
  }

  propsAndStateOnChange = {
    list: this._list.bind(this)
  }

  _list(nextProps, nextState) {
    if (nextProps.list.success) {
      nextState.playUrl = nextProps.list.data[0].playUrl
      nextState.playKey = new Date().getTime()
      return true;
    }
    Wizmessage.destroy()
    Wizmessage.error(nextProps.list.msg);
    return false
  }

  componentWillMount() {}

  componentDidMount() {
    this._getData();
  }

  _getData() {
    const startDate = this.query.startDate ? moment(this.query.startDate).format('YYYY-MM-DD') : ''
    this.doAction({
      path: 'video/listByPage',
      payload: {
        key: 'listByPage',
        apiParams: {
          meetingNo: this.query.meetingNo,
          startDate
        },
      },
    });
  }

  handleClick = (item, index) => {
    this.setState({ playUrl : item.playUrl, playKey: new Date().getTime(), activeKey: index, visible: false })
  }

  handleDownload = ()  => {
    window.location.href = `${this.state.playUrl}?download=y`
  }

  onVisibleChange = () => {
    this.setState({ visible: !this.state.visible })
  }

  createMenu = _list => (
    <WizMenu className="list-group-wrp">
      {
        _list.map((val,index)=> (
          <WizMenu.Item key={index}>
            <div className={classnames("list-item-wrp", this.state.activeKey === index && 'list-item-active')} onClick={()=>this.handleClick(val,index)}>
              <span className="list-item-title">{`录像${index+1}`}</span>
              <div className="list-item-desc">{ val.endDate }</div>
            </div>
          </WizMenu.Item>
        ))
      }
    </WizMenu>
  );
  
  _render() {
    const { list, videoLoading } = this.props;
    const { playUrl, playKey, visible } = this.state
    const _list = list.data && list.data.length ? list.data : []
    // const watermarkStyle = {
    //   position: 'relative',
    //   top: '30px',
    //   padding: "30px",
    //   fontSize: "16px",
    //   color: 'rgba(255, 255, 255, 0.7)',
    // };
    const sources = {
      sd: {
        format: '',
        play_url: playUrl,
        duration: 0,
        bitrate: 0,
        height: 0,
        width: 0,
        size: 0,
      },
    };
    
    const props = {
      // standalone: true,
      // title: '2018 我们如何与世界相处？',
      // autoplay: true,
      id: new Date().getTime().toString(),
      cover: '',
      duration: 200,
      sources,
      locale: 'zh-Hans',
      initialObjectFit: 'contain',
      shouldObserveResize: true, //是否监听窗口 resize
      disablePictureInPicture: true //禁用画中画功能
    }

    return (
      <WizSpin spinning={videoLoading} tip="数据加载中..." wrapperClassName="video-spinning-wrp">
      {
        _list && _list.length ? <WizLayout className="video-page">
        <WizLayout.Header>
          <div className="video-header">
            <h1 className="video-header-title">{ this.query.title ? base64url.decode(this.query.title) : null }</h1>
            <div className="video-header-extra">
            { !this.query.appVersion ? <WizButton type="primary" className="btn-download" onClick={this.handleDownload}>下载</WizButton> : null }
              <WizDropdown overlay={this.createMenu(_list)} placement="bottomRight" trigger={['click']} onVisibleChange={this.onVisibleChange}>
                <a className="video-dropdown-link" onClick={e => e.preventDefault()}>
                  <WizIcon type="unordered-list" className="btn-icon" />
                </a>
              </WizDropdown>
            </div>
          </div>
        </WizLayout.Header>
        <WizLayout.Content className="video-wrapper" style={{ height: window.innerHeight - 59 }}>
          {
            !visible ? <PlayerContainer {...props} key={playKey}>
              <MessageContext.Consumer>
                {({subscribeEvent}) => <LayerTest subscribeEvent={subscribeEvent} />}
              </MessageContext.Consumer>
            </PlayerContainer> : <div className="video-empty"></div>
          }
        </WizLayout.Content>
        </WizLayout> : <WizEmpty/>
      }
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { video } = state;
  const list = modelUtils.getModelEntity(video, 'listByPage');
  const load = modelUtils.getLoadingState(state, 'video');
  return {
    list,
    ...load
  };
};

export default connect(mapStateToProps)(VideoList);
